import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

export function BrandLogos(props) {
    const {
        headline,
        brandLogos: logos,
        closingCopy
    } = props;

    // eslint-disable-next-line arrow-body-style
    const renderLogos = (pics) => {
        return pics.map((pic) => (
            <div className={cn('logo')}>
                <img key={pic.url} loading="lazy" src={pic.url} alt={pic.alt} />
            </div>
        ));
    };

    // eslint-disable-next-line camelcase
    const half_length = Math.ceil(logos.length / 2);

    return (
        <section className={cn('brandlogos-section', 'ulx__aem-section')} id="Partnerships">
            <div className={cn('section-header')}>
                <h2>{headline}</h2>
                <p>{closingCopy}</p>
            </div>
            <div className={cn('section-content')}>
                <div className={cn('logos')}>
                    {renderLogos(logos.slice(0, half_length))}
                    {renderLogos(logos.slice(0, half_length))}
                </div>
                <div className={cn('logos', 'reverse')}>
                    {renderLogos(logos.slice(half_length))}
                    {renderLogos(logos.slice(half_length))}
                </div>
            </div>
        </section>

    );
}

BrandLogos.propTypes = {
    headline: PropTypes.string.isRequired,
    closingCopy: PropTypes.string.isRequired,
    brandLogos: PropTypes.arrayOf(PropTypes.shape(
        {
            url: PropTypes.string.isRequired,
            alt: PropTypes.string.isRequired
        }
    )).isRequired
};

export default BrandLogos;
